var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6117 22.8553H13.4571C12.9186 22.8553 12.4815 22.4197 12.4815 21.8831C12.4815 21.3464 12.9186 20.9108 13.4571 20.9108H20.6117C21.1502 20.9108 21.5873 21.3464 21.5873 21.8831C21.5873 22.4197 21.1502 22.8553 20.6117 22.8553ZM11.1937 13.3778C11.1937 13.7369 10.901 14.026 10.5433 14.026H5.33998C4.97965 14.026 4.68957 13.7369 4.68957 13.3778V10.137C4.68957 9.78054 4.97965 9.48886 5.33998 9.48886H10.5433C10.901 9.48886 11.1937 9.78054 11.1937 10.137V13.3778ZM9.55466 22.8553H5.65218C5.11364 22.8553 4.67656 22.4197 4.67656 21.8831C4.67656 21.3464 5.11364 20.9108 5.65218 20.9108H9.55466C10.0932 20.9108 10.5303 21.3464 10.5303 21.8831C10.5303 22.4197 10.0932 22.8553 9.55466 22.8553ZM28.1045 6.24805H3.38874C2.31166 6.24805 1.4375 7.11918 1.4375 8.19254V25.0448C1.4375 26.1194 2.31166 26.9893 3.38874 26.9893H28.1045C29.1829 26.9893 30.0557 26.1194 30.0557 25.0448V8.19254C30.0557 7.11918 29.1829 6.24805 28.1045 6.24805Z",
    fill: "#6C6C6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg);
export default __webpack_public_path__ + "static/media/card-img.e2a1cd390973901551719e7e0bb94fc7.svg";
export { ForwardRef as ReactComponent };